import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBmFkkQhSozzKTW4jChoM4ica4nFFTBBlk",
  authDomain: "kolvn-meeting-room-booking-app.firebaseapp.com",
  projectId: "kolvn-meeting-room-booking-app",
  storageBucket: "kolvn-meeting-room-booking-app.firebasestorage.app",
  messagingSenderId: "438448641081",
  appId: "1:438448641081:web:0a3c94cc9218c6f61a69e8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { db, auth, provider };
